import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'
import { COLUMNS_CONFIG, DEFAULT_COLUMNS, FIELDS, SUBSCRIPTIONS } from 'frontend/shifts/shifts-table-helpers'

export const ShiftDataModelTypeConfig: IDataModelTypeConfig = {
  fields: FIELDS,
  subscriptions: SUBSCRIPTIONS,
  defaultColumns: DEFAULT_COLUMNS,
  columnConfig: COLUMNS_CONFIG,
}
